import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getUserSelectedAccountCode } from "../../app/appSelectors";
import { getLiteTradeAssets, makeSelectorGetLiteTradeAssetInfo } from "../LiteTrade/liteTradeSelectors";
import Asset from "./Asset";

export const useAssetInstance = (symbol) => {
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);
    const assetInfo = useSelector(makeSelectorGetLiteTradeAssetInfo(symbol));
    const assets = useSelector(getLiteTradeAssets);
    const [assetInstance, setAssetInstance] = useState(null);
    const [isAssetInstanceReady, setIsAssetInstanceReady] = useState(false);

    useEffect(() => {
        if (assetInfo && assets && selectedAccountCode) {
            setAssetInstance(new Asset(assetInfo, {
                assets,
                selectedAccountCode,
            }));
        }
    }, [assetInfo, assets, selectedAccountCode]);

    useEffect(() => {
        if (assetInstance) {
            assetInstance.isReady().then(() => {
                setIsAssetInstanceReady(true);
            });
        }
    }, [assetInstance]);

    return useMemo(() => ({ assetInstance, isAssetInstanceReady }), [assetInstance, isAssetInstanceReady]);
}
